/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_Nobyok_DescInputs */

const en_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI works out of the box.`)
};

const de_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI funktioniert sofort.`)
};

const fr_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA fonctionne immédiatement.`)
};

const es_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA funciona directamente.`)
};

const it_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'AI funziona subito, senza configurazione.`)
};

const nl_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI werkt direct uit de doos.`)
};

const pl_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI działa od razu, bez konfiguracji.`)
};

const fi_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoäly toimii suoraan käyttövalmiina.`)
};

const da_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI virker med det samme.`)
};

const sv_landing_trust_nobyok_desc = /** @type {(inputs: Landing_Trust_Nobyok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI fungerar direkt ur lådan.`)
};

/**
* | output |
* | --- |
* | "AI works out of the box." |
*
* @param {Landing_Trust_Nobyok_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_nobyok_desc = /** @type {((inputs?: Landing_Trust_Nobyok_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_Nobyok_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_nobyok_desc(inputs)
	if (locale === "fr") return fr_landing_trust_nobyok_desc(inputs)
	if (locale === "es") return es_landing_trust_nobyok_desc(inputs)
	if (locale === "it") return it_landing_trust_nobyok_desc(inputs)
	if (locale === "nl") return nl_landing_trust_nobyok_desc(inputs)
	if (locale === "pl") return pl_landing_trust_nobyok_desc(inputs)
	if (locale === "fi") return fi_landing_trust_nobyok_desc(inputs)
	if (locale === "da") return da_landing_trust_nobyok_desc(inputs)
	if (locale === "sv") return sv_landing_trust_nobyok_desc(inputs)
	return en_landing_trust_nobyok_desc(inputs)
});